import { API } from "aws-amplify"

import * as Sentry from "@sentry/react"

const defaultProps = {
  response: true,
  headers: { "x-api-key": window.atob(process.env.REACT_APP_AMPLIFY_API_API_KEY) },
}

const helperServicePath = "helper"


export const feedbackSend = async (feedback) => {
  const { eventId, fullName, email, comments } = feedback

  if (!eventId || typeof eventId !== "string") return
  if (!fullName || typeof fullName !== "string") return
  if (!email || typeof email !== "string") return
  if (!comments || typeof comments !== "string") return

  try {
    await API.post(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `/busp/${helperServicePath}/sendFeedback`,
      {
        ...defaultProps,
        body: feedback,
      }
    )
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const submitRegistration = async (registration) => {
  try {
    const request = await API.post(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `registrationRequests/submitRequests`,
      {
        ...defaultProps,
        body: registration,
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const fetchRequests = async () => {
  try {
    const request = await API.get(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `registrationRequests/fetchRequests`,
      {
        ...defaultProps,
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const updateRequest = async (requestUpdate) => {
  try {
    const request = await API.post(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `registrationRequests/updateRequests`,
      {
        ...defaultProps,
        body: requestUpdate,
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const fetchApprovedUsers = async () => {
  try {
    const request = await API.get(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `registrationRequests/fetchApprovedUsers`,
      {
        ...defaultProps,
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}
export const updateApprovedUsers = async (update) => {
  try {
    const request = await API.post(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `registrationRequests/updateApprovedUsers`,
      {
        ...defaultProps,
        body: update,
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const sendRegistrationLink = async (details) => {
  try {
    const request = await API.post(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `registrationRequests/sendRegistration`,
      {
        ...defaultProps,
        body: details,
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const fetchAdminUsers = async () => {
  try {
    const request = await API.post(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `mainUserPool/fetchUsers`,
      {
        ...defaultProps,
        body: {},
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const fetchUserGroups = async (user) => {
  try {
    const request = await API.post(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `mainUserPool/fetchUserGroups`,
      {
        ...defaultProps,
        body: { username: user },
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}

export const submitOfficers = async (submission) => {
  try {
    const request = await API.post(
      process.env.REACT_APP_AMPLIFY_API_ENDPOINT_NAME,
      `registrationRequests/submitOfficers`,
      {
        ...defaultProps,
        body: submission,
      }
    )
    return request
  } catch (error) {
    Sentry.captureException(error, { tags: { context: "api", noFallback: true } })

    throw error
  }
}
